/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Outcome of a /affiliate call.
 *
 * - already_affiliated: user already has an active matching affiliation
 * - newly_created: a new affiliation was created/claimed in this call
 * - nothing_found: broad-match found no eligible affiliation to claim
 * - remediation_needed: membership intent could not be claimed (eligibility mismatch)
 */
export type AffiliateOutcome =
  (typeof AffiliateOutcome)[keyof typeof AffiliateOutcome];

export const AffiliateOutcome = {
  already_affiliated: "already_affiliated",
  newly_created: "newly_created",
  nothing_found: "nothing_found",
  remediation_needed: "remediation_needed",
} as const;
